import * as Yup from "yup";

export const initialValues = {
  roleId: null,
  roleName: null,
  roleCode: null,
  roleNameEn: null,
  defaultRoleCode: null,
  roleHr: "Y",
  description: null,
  descriptionEn: null,
};

const UserRoleSchema = Yup.object().shape({
  roleName: Yup.string().required("Please enter."),
  roleNameEn: Yup.string().required("Please enter."),
  defaultRoleCode: Yup.string().required("Please select."),
});



export default UserRoleSchema;
